import intlTelInput from "intl-tel-input";



document.addEventListener('DOMContentLoaded', () => {

    initializeIntlTelInput();

    function initializeIntlTelInput() {

        let input = document.querySelector("#phoneintl");

        if (input) {

            const iti = intlTelInput(input, {
                autoPlaceholder: "aggressive",
                separateDialCode: true,
                nationalMode: true,
                initialCountry: "auto",
                formatOnDisplay: true,
                geoIpLookup: function (callback) {
                    if (!window.isLogged) {
                        fetch('https://ipinfo.io?token=bdf61023d6d85f')
                            .then(response => response.json())
                            .then(data => {
                                let countryCode = (data && data.country) ? data.country : "";
                                callback(countryCode);
                            });
                    }
                },
                utilsScript: window.utilsScriptPath


            });

            const handleChange = () => {
                console.log('fire')
                if (iti.isValidNumber()) {
                    console.log('isvalid')
                    input.value = iti.getNumber(intlTelInputUtils.numberFormat.NATIONAL);
                }

                let phoneNum = iti.getNumber();
                let number = document.querySelector("#phone");
                if (number) {
                    number.value = phoneNum;
                    number.dispatchEvent(new Event('input'));
                }

            }

            input.addEventListener('keyup', handleChange);
            input.addEventListener('change', handleChange);

        }

    }

});
